import React from "react"

interface ButtonGroupProps {
    children?: React.ReactNode
    className?: string
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ children, className }) => {
    return (
        <div
            className={`flex w-full flex-col gap-y-2 md:w-auto md:flex-row md:gap-x-2 [&_*]:mb-2 [&_*:not(:last-child)]:mr-2 [[role=dialog]_&]:justify-end ${className ?? ""}`}
        >
            {children}
        </div>
    )
}

export default ButtonGroup
